/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PromoBannerAdminDto = {
  /**
   * ID
   */
  id: string;
  /**
   * 노출 위치
   */
  placement: PromoBannerAdminDto.placement;
  /**
   * 카테고리 ID (EXPLORE_CATEGORY만, "전체"=ALL). HOME이면 null
   */
  categoryId?: Record<string, any> | null;
  /**
   * 노출 플랫폼 타겟 (도입 전 배너는 ALL)
   */
  platform: PromoBannerAdminDto.platform;
  /**
   * 링크 타입
   */
  linkType: PromoBannerAdminDto.linkType;
  /**
   * 대상 ID (quizPack은 legacyId)
   */
  targetId: string;
  /**
   * 배너 이미지 URL
   */
  imageUrl: string;
  /**
   * 활성화 여부
   */
  isActive: boolean;
  /**
   * 같은 노출위치 내 롤링 순서 (0부터)
   */
  ordering: number;
  /**
   * 생성일
   */
  createdAt: string;
  /**
   * 수정일
   */
  updatedAt: string;
};
export namespace PromoBannerAdminDto {
  /**
   * 노출 위치
   */
  export enum placement {
    HOME = "HOME",
    EXPLORE_CATEGORY = "EXPLORE_CATEGORY",
    MY_PAGE = "MY_PAGE",
  }
  /**
   * 노출 플랫폼 타겟 (도입 전 배너는 ALL)
   */
  export enum platform {
    APP = "APP",
    WEB = "WEB",
    ALL = "ALL",
  }
  /**
   * 링크 타입
   */
  export enum linkType {
    QUIZ_PACK = "quizPack",
    CURRICULUM = "curriculum",
    EXPLORE_TOURNAMENT = "exploreTournament",
    BATTLE = "battle",
    TOURNAMENT = "tournament",
    VOCAB = "vocab",
    URL = "url",
  }
}
